var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_39817",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_39817)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_39817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_39817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33326H16V2.28564H0V5.33326Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7141H16V10.6665H0V13.7141Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6666H16V5.33325H0V10.6666Z",
    fill: "#FFD133"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishFlag);
export default __webpack_public_path__ + "static/media/SpanishFlag.20993d293fd3c15936449d31b97d0bee.svg";
export { ForwardRef as ReactComponent };